import { Context, Effect } from "effect";
import type { Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { R2Download } from "../../api/r2/model.ts";
import type { R2Action, R2Settlement, R2Snapshot } from "./model.ts";

export class R2BrowserIo extends Context.Service<R2BrowserIo, {
  readonly pickFile: Effect.Effect<File | null, ResourceFailure>;
  readonly promptKey: (filename: string) => Effect.Effect<string | null, ResourceFailure>;
  readonly confirm: (key: string) => Effect.Effect<boolean, ResourceFailure>;
  readonly download: (descriptor: R2Download) => Effect.Effect<void, ResourceFailure>;
}>()("workerstation/frontend/R2BrowserIo") {}
export interface R2Session {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<R2Snapshot>>;
  readonly settlements: Effect.Effect<readonly R2Settlement[]>;
  readonly dispatch: (action: R2Action) => Effect.Effect<void>;
}
export class R2Sessions extends Context.Service<R2Sessions, {
  readonly open: Effect.Effect<R2Session, never, Scope.Scope>;
}>()("workerstation/frontend/R2Sessions") {}
